<div class="welcome-room-transition-wrapper" @simpleFadeAnimation>
  <div class="avatar-container">
    @if (isVisible) {
      <div class="onboarding-message" @fadeOutTransition>
        You're ready to go. We hope you have a wonderful time in the Scootaverse!
      </div>
    }

    <div class="video-wrapper" [ngClass]="{ hidden: shouldShowAvatarVideo }">
      <app-camera
        #camera
        [onVideoPlaying]="onVideoPlaying"
        [onVideoTimeout]="onVideoTimeout"
        [hasBorder]="true"
      ></app-camera>
    </div>
    @if (shouldShowAvatarPicture) {
      <div>
        <profile-picture [user]="user" [borderWidth]="'5'" [size]="295.31"></profile-picture>
      </div>
    }

    @if (!isVisible) {
      <div class="welcome-text" @fadeInTransition>{{ welcomeText() }}</div>
      <mat-progress-bar class="loading-bar" mode="indeterminate"></mat-progress-bar>

      @if (isWaitingForHost()) {
        <div class="waiting-host-buttons-wrapper">
          @if (hasBadgeQuestions()) {
            <div class="waiting-host-button" (click)="redirectToButtonAction('badge')">Edit Smart Badge</div>
          }
          <div class="waiting-host-button" (click)="redirectToButtonAction('permissions')">
            Test Camera and Mic Permissions
          </div>
          @if (onboardingExperience()) {
            <div class="waiting-host-button" (click)="redirectToButtonAction('orientation')">
              View Orientation Again
            </div>
          }
        </div>
      }
    }
  </div>
</div>
